import Vue from 'vue'
import axios from 'axios'
import API from '@/common/api'
import store from '..'
import router from '@/router'
import moment from 'moment/moment'
import { flattenShopItemProperty } from '@/components/Shop/flattenShopItemProperty'
import { f } from 'html2pdf.js'

// 선택한 상위옵션에 따라 서브옵션을 필터링 하는 함수
function cleanInvalidSubOptions (detailOptions) {
  const keysToRemove = []
  Object.keys(detailOptions).forEach(key => {
    const parts = key.split('_unique_')
    if (parts.length === 4) {
      /**
       * 옵션키
       * shopItemId: shopItemId
       * optionId: shopItem의 optionId
       * optionItemId: shopItem의 optionId 중 selectedItemId (서브옵션일 때만 존재함)
       * selfId: selectedItem에 설정된 subOptionId (서브옵션일 때만 존재함)
       */
      const [shopItemId, optionId, optionItemId, slefId] = parts
      const parentKey = `${shopItemId}_unique_${optionId}`
      const parent = detailOptions[parentKey]
      const isValid = parent && parent.optionItems && parent.optionItems.some(
        item => item.optionItemId === optionItemId
      )
      if (!isValid) {
        keysToRemove.push(key)
      }
    }
  })
  return keysToRemove
}


export default {
  namespaced: true,
  state: {
    billingInfo: null,
    billingCount: null, // 주문카운트 (아이템별qty, 카테고리별 아이템qty)
    waitingOrder: null, // 주문대기 시간 체크
    intervalId: null, // 샵아이템 이용시간 체크를 위한 인터벌id
    currencyCode: 'KRW',
    itemProperty: null,
    shopOptions: null,
    categoryNav: {}, // 하나의 샵을 뷰어 전체로 사용하는 업장을 위한 내비게이션용 카테고리 내비게이션(1뎁스만 필요함)
    categoryProperty: {}, // nav에서 활성화 처리를 위해 필요한 페이지아이디별 카테고리 정보
    categoryLimitSettings: {},
    detailItemId: null, // 현재 보고있는 디테일 shopItemId
    detailItemInfo: null, // 현재 보고있는 디테일 shopItem info
    isOpenDetailOption: false,
    detailOptions: null, // 전송을 위한 옵션데이터
    detailOptionArray: [], // 렌더링을 위한 옵션데이터
    detailSubOptions: null, // 옵션의 옵션 데이터
    activeSubOption: null, // 활성화된 서브옵션
    shopSettings: null,
    shopCatCode: null,
    catCodes: null,
    preset: {},
    defaultAvailableTime: [ // 프리셋지정하지 않은 경우
      { id: 'mon', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
      { id: 'tue', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
      { id: 'wed', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
      { id: 'thu', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
      { id: 'fri', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
      { id: 'sat', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] },
      { id: 'sun', available: true, time: [{ from: {hh: '00', mm: '00'}, to: {hh: '24', mm: '00'} }] }
    ],
    hiddenItems: [],
    hiddenGroup: [],
    callStaff: {
      isActive: false,
      items: []
    },
    shopGuest: null,
    shopOrderTimeout: null, // 주문시간 만료
    isShopGuestCount: null // 인원선택 상태인가? (이때만 언어선택ui 노출)
  },
  mutations: {
    setShopGuestCount(state, data) {
      state.isShopGuestCount = data || null
    },
    setWaitingOrder (state, data) {
      if (!data) return
      const { catCode, timeLeft } = data
      if (!catCode) return
      const t = Number(timeLeft)
      if (!Number.isFinite(t) || t <= 0) {
        if (state.waitingOrder && state.waitingOrder[catCode]) {
          Vue.delete(state.waitingOrder, catCode) // ★ 반응성 삭제
        }
        return
      }

      if (!state.waitingOrder) {
        state.waitingOrder = Object.create(null)
      }
      Vue.set(state.waitingOrder, catCode, t) // ★ 반응성 추가/갱신
    },
    setBillingInfo (state, data) {
      if (!(data && data.catCode)) {
        state.billingInfo = null
        state.billingCount = null
        return
      }
      const { catCode, billingInfo, billingCount } = data

      // state가 혹시 null일 수 있다면 방어
      if (!state.billingInfo) {
        state.billingInfo  = {}
      }
      if (!state.billingCount) {
        state.billingCount = {}
      }
      Vue.set(state.billingInfo, catCode, billingInfo)
      Vue.set(state.billingCount, catCode, billingCount)
    },
    setShopCurrency (state, currency) {
      state.currencyCode = currency || 'KRW'
    },
    setShopOrderTimeout (state, data) {
      const { shopPageId, isTimeout } = data
      if (!state.shopOrderTimeout) {
        state.shopOrderTimeout = {}
      }
      Vue.set(state.shopOrderTimeout, shopPageId, isTimeout)
    },
    setShopGuest (state, data) {
      state.shopGuest = data ? {
          billingStayNo: data.billingStayNo,
          guestInfo: data.guestInfo,
          ...data.guestInfo && {
            guestInfos: data.guestInfo.guestInfos,
            guestCount: data.guestInfo.guestInfos && data.guestInfo.guestInfos.map(info => info.count).reduce((a, b) => a + b, 0),
            orderUUID: data.guestInfo.orderUUID
          },
          startTime: data.startTime
        } : null
    },
    setCallStaff (state, isActive) {
      state.callStaff.isActive = isActive
    },
    setCallStaffItems (state, items) {
      state.callStaff.items = items || []
    },
    setHiddenItem (state, { shopItemId, isHidden }) {
      const exists = state.hiddenItems.includes(shopItemId)
      if (isHidden && !exists) {
        // 추가
        state.hiddenItems = [...state.hiddenItems, shopItemId]
      } else if (!isHidden && exists) {
        // 제거
        const index = state.hiddenItems.indexOf(shopItemId)
        state.hiddenItems = [
          ...state.hiddenItems.slice(0, index),
          ...state.hiddenItems.slice(index + 1)
        ]
      }
    },
    setHiddenGroupIds (state, { categoryId, isHidden }) {
      const exists = state.hiddenGroup.includes(categoryId)
      if (isHidden && !exists) {
        // 추가
        state.hiddenGroup = [...state.hiddenGroup, categoryId]
      } else if (!isHidden && exists) {
        // 제거
        const index = state.hiddenGroup.indexOf(categoryId)
        state.hiddenGroup = [
          ...state.hiddenGroup.slice(0, index),
          ...state.hiddenGroup.slice(index + 1)
        ]
      }
    },
    SET_INTERVAL_ID(state, id) {
      state.intervalId = id
    },
    CLEAR_INTERVAL(state) {
      if (state.intervalId) {
        clearInterval(state.intervalId)
        state.intervalId = null
      }
    },
    setCatCodes (state, data) {
      if (!(data && data.catCode && data.shopPageId)) return
      const { shopPageId, catCode } = data

      // state가 혹시 null일 수 있다면 방어
      if (!state.catCodes) {
        state.catCodes  = {}
      }
      Vue.set(state.catCodes, shopPageId, catCode)
    },
    setCategoryProperty (state, data) {
      // 1뎁스id를 key로 하위카테고리id를 모두 배열로
      function collectCategories(input) {
        const result = {}
        function traverse(node, rootId) {
          if (!result[rootId]) {
            result[rootId] = new Set()
          }
          result[rootId].add(node.categoryId)
          if (node.subCategory) {
            node.subCategory.forEach(sub => traverse(sub, rootId))
          }
        }
        input.forEach(item => {
          traverse(item, item.categoryId)
        })
        // Set을 배열로 변환
        Object.keys(result).forEach(key => {
          result[key] = Array.from(result[key])
        })
        return result
      }
      // 세팅이 있는 카테고리만 별도 객체로 분리
      function collectActiveCategoryOpts(arr) {
        const result = {}

        function walk (list) {
          if (!Array.isArray(list)) return
          for (const item of list) {
            if (!item) continue

            const setting = item.categoryOpt
            const limit = setting && setting.limitItemCount
            const hasActive = limit && limit.active
            const count = limit && limit.itemCount
              ? Number(limit.itemCount)
              : NaN

            if (setting && limit && hasActive && isFinite(count) && count >= 1 && item.categoryId) {
              result[item.categoryId] = setting
            }

            if (Array.isArray(item.subCategory)) {
              walk(item.subCategory)
            }
          }
        }

        walk(arr)
        return result
      }

      if (data && data.shopPageId && data.category) {
        const categoryData = collectCategories(data.category)
        state.categoryProperty = {
          ...state.categoryProperty,
          [data.shopPageId]: categoryData
        }
        state.categoryNav = {
          ...state.categoryNav,
          [data.shopPageId]: data.category
        }
        state.categoryLimitSettings = {
          ...state.categoryLimitSettings,
          ...collectActiveCategoryOpts(data.category)
        }
      }
    },
    setItemProperty (state, data) {
      state.itemProperty = {
        ...(state.itemProperty || {}),
        ...data
      }
    },
    addItemProperty (state, data) {
      const target = state.itemProperty
      for (const id in data) {
        if (Object.prototype.hasOwnProperty.call(target, id)) {
          target[id] = data[id]
        } else {
          Vue.set(target, id, data[id])
        }
      }
    },
    setDetailItem (state, data) {
      state.detailItemId = (data && data.shopItemId) || data
      if (data && data.shopItemId) {
        const item = state.itemProperty[data.shopItemId]
        Vue.set(state, 'detailOptions', {})
        Vue.set(state, 'detailItemInfo', {
          shopItemId: data.shopItemId,
          shopItemName: item.shopItemName,
          categoryId: data.categoryId,
          quantity: data.selectOptionByQuantity
            ? 1
            : (data.selectQuantity && data.selectQuantity.min) || 1,
          selectOptionByQuantity: data.selectOptionByQuantity === true,
          selectQuantity: data.selectQuantity,
          hasOption: data.hasOption,
          ...data.isCallItem && { isCallItem: data.isCallItem },
          ...data.price && { price: data.price },
          ...data.pId && { pId: data.pId },
          ...data.availableTime && { availableTime: data.availableTime },
          ...data.status && { status: data.status },
          ...data.passFirstOption && { passFirstOption: data.passFirstOption },
          // 장바구니에서 옵션변경을 위해 상세를 연 경우
          ...data.cartItemId && {
            cartItemId: data.cartItemId
          }
        })
      } else {
        state.detailOptions = null
      }
    },
    setDetailItemQuantity (state, quantity) {
      state.detailItemInfo.quantity = quantity
    },
    setDetailOptions (state, optionData) {
      // 옵션 및 서브옵션 추가
      if (optionData) {
        optionData.forEach(item => {
          // 기존에 item.id가 존재하면 해당 항목의 optionItems와 isValid 값을 갱신
          if (state.detailOptions[item.uniqueId]) {
            Vue.set(state.detailOptions, item.uniqueId, {
              ...state.detailOptions[item.uniqueId],
              optionItems: item.optionItems,
              isValid: item.isValid
            })
          } else {
            // 새로운 항목이 추가되면 Vue.set을 사용해 동적으로 추가
            Vue.set(state.detailOptions, item.uniqueId, {
              ...item.id && {
                id: item.id
              },
              ...item.optionId && {
                optionId: item.optionId
              },
              ...item.name && {
                name: item.name
              },
              ...item.pId && {
                pId: item.pId
              },
              optionItems: item.optionItems,
              isValid: item.isValid,
              ...item.parentOption && {
                parentOption: item.parentOption
              }
            })
          }
        })
      }
      // 옵션 추가 이후, 유효하지 않은 서브옵션 제거
      const invalidKeys = cleanInvalidSubOptions(state.detailOptions)
      invalidKeys.forEach(key => {
        Vue.delete(state.detailOptions, key)
      })
    },
    setActiveSubOption (state, uniqueId) {
      state.activeSubOption = uniqueId || null
    },
    setDetailOptionArray (state, optionList) {
      state.detailOptionArray = optionList || []
    },
    setShopSettings (state, data) {
      state.shopSettings = {
        ...state.shopSettings,
        [data.shopPageId]: data.settings
      }
    },
    setPreset (state, data) {
      if (data) {
        Object.values(data).forEach(item => {
          const presetType = item.presetType
          if (state.preset[presetType]) {
            state.preset[presetType][item.presetId] = item
          } else {
            state.preset[presetType] = {
              [item.presetId]: item
            }
          }
        })
      }
    },
    setOpenDetailOption (state, isOpen) {
      state.isOpenDetailOption = isOpen
    }
  },
  actions: {
    setShopOrderTimeout ({ commit, rootGetters }, data) {
      commit('setShopOrderTimeout', data)
      if (data.isTimeout) {
        // 주문종료된 페이지 장바구니 비움
        const shopCartItems = rootGetters['cart/getList'](data.shopPageId)
        if (shopCartItems) {
          shopCartItems.map(item => {
            const cartId = item.cartId
            commit('cart/delList', cartId, { root: true })
          })
        }
      }
    },
    // item property 최초 또는 대량 로드
    ingestItemProperty({ commit }, rawMap) {
      const out = Object.create(null)

      function normalizeQuantity (quantity) {
        const min = Number(quantity && quantity.min)
        const max = Number(quantity && quantity.max)

        return {
          min: Number.isFinite(min) && min > 0 ? min : 1,
          max: Number.isFinite(max) && max > 0 ? max : 10
        }
      }

      function normalizeDesc (arr = []) {
        return arr.filter(v => {
          if (typeof v === 'string') {
            return v.length > 0
          }

          if (v && typeof v === 'object' && 'desc' in v) {
            return v.desc && Object.keys(v.desc).length > 0
          }

          return false
        })
      }

      function normalizeOptionItems (optionItems = []) {
        if (!Array.isArray(optionItems)) return []
        return optionItems.filter(item => item && item.isActive !== false)
      }

      function normalizeOptionList (optionList = []) {
        if (!Array.isArray(optionList)) return []
        return optionList.map(option => {
          if (!option || typeof option !== 'object') return option

          return {
            ...option,
            optionItems: normalizeOptionItems(option.optionItems)
          }
        }).filter(option => option && option.optionItems && option.optionItems.length > 0)
      }

      function normalizeShopItem (shopItem) {
        if (!shopItem || typeof shopItem !== 'object') return shopItem

        const normalizedOptionProperty = shopItem.optionProperty
          ? normalizeOptionList(shopItem.optionProperty)
          : shopItem.optionProperty

        const normalizedOption = shopItem.option
          ? normalizeOptionList(shopItem.option)
          : shopItem.option

        const normalizedShopItem = {
          ...shopItem,
          quantity: normalizeQuantity(shopItem && shopItem.quantity),
          ...(shopItem.descList && {
            descList: normalizeDesc(shopItem.descList)
          }),
          ...(shopItem.optionProperty && {
            optionProperty: normalizedOptionProperty
          }),
          ...(shopItem.option && {
            option: normalizedOption
          })
        }

        // option은 비어있고 optionProperty는 유효하면 option에 복사
        if (
          Array.isArray(normalizedShopItem.option) &&
          normalizedShopItem.option.length === 0 &&
          Array.isArray(normalizedShopItem.optionProperty) &&
          normalizedShopItem.optionProperty.length > 0
        ) {
          normalizedShopItem.option = normalizedShopItem.optionProperty
        }

        return normalizedShopItem
      }

      if (rawMap && typeof rawMap === 'object') {
        for (const key in rawMap) {
          if (!Object.prototype.hasOwnProperty.call(rawMap, key)) continue

          const shopItem = rawMap[key]
          const normalizedShopItem = normalizeShopItem(shopItem)

          out[key] = flattenShopItemProperty(normalizedShopItem, false)
        }
      }

      commit('setItemProperty', out)
    },
    // item property 일부만 추가/갱신 (아직 api가 따로 있진 않음)
    upsertItemProperty({ commit }, patchMap) {
      const out = Object.create(null)
      for (const key in patchMap) {
        if (!Object.prototype.hasOwnProperty.call(patchMap, key)) continue
        out[key] = flattenShopItemProperty(patchMap[key], false)
      }
      commit('addItemProperty', out)
    },
    async getLastVersion({ state }, pageId) {
      try {
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-last-version&siteid=${API.SITE_INFO.site}&pageId=${pageId}`)
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res && res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    async getOrderPageProperty({ state, commit, dispatch }, data) {
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-order-page-property&siteid=${API.SITE_INFO.site}&pageId=${data.shopPageId}`).then(res => {
        // return res && res.data && res.data.message
        return res.response && res.response.data
          ? res.response.data
          : res.data && res.data.errorMessage ? JSON.parse(res.data.errorMessage) : res && res.data && res.data.message
      }).catch((ex) => {
        console.log(ex)
        return ex && ex.response
      })
    },
    // 프리셋 아이템(ids) 호출
    async getStorePresetItems({ state }, presetIds) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-order-api',
          func: 'get-store-preset-items',
          siteid: API.SITE_INFO.site,
          presetIds: presetIds
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // 옵션 아이템(ids) 호출
    async getStoreOptionItems({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-order-api',
          func: 'get-store-option-items',
          siteid: API.SITE_INFO.site,
          shopItemId: data.shopItemId,
          ids: data.ids
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // 옵션 아이템(ids) 호출
    async getStoreSubOptionItems({ state }, data) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-order-api',
          func: 'get-store-sub-option-items',
          siteid: API.SITE_INFO.site,
          optId: data.optId,
          selectedOptionItemId: data.selectedOptionItemId,
          subIds: data.subIds
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // 옵션 아이템 중 상품인 경우(shopItemIds) 호출
    async getShopItems({ state }, shopItemIds) {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-order-api',
          func: 'get-shop-items',
          siteid: API.SITE_INFO.site,
          shopItemIds: shopItemIds
        })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    },
    // 임시코드, 주문시간제한이 있는 샵에서의 시작시간 호출
    async getGuestOrderStartTime({ }, ota) {
      try {
        return {
          startTime: '2025-09-18T07:45:00.799Z'
        }
      } catch (ex) {
        return false
      }
    }
  },
  getters: {
    getShopSettings: state => shopPageId => (shopPageId && state.shopSettings && state.shopSettings[shopPageId]) || {},
    getShopGuestSettings: state => shopPageId => (shopPageId && state.shopSettings && state.shopSettings[shopPageId] && state.shopSettings[shopPageId].guestSettings) || {},
    getShopOrderLimit: state => shopPageId => (shopPageId && state.shopSettings && state.shopSettings[shopPageId] && state.shopSettings[shopPageId].orderLimitSetting) || {},
    getItemProperties: state => state.itemProperty,
    getItemProperty: (state, getters) => (shopItemId, isStore) => {
      const item = state.itemProperty && state.itemProperty[shopItemId]
      if (!item) return null
      /**
       * itemProperty 세팅값에 따라 변경
       * 주문가능수량(quantity.max)
       * - quantityByGuest 이면 guestCount * item.quantity.max
       * - quantityByGuest 값이 없거나 false이면 item.quantity.max
       * item.quantity.max를 못찾으면 기본값 10
       * isStore에만 적용하려 했으나 백엔드에서 체크하기 힘들어서 pass..
       */
      const excludeGroupIds = Array.isArray(item.excludeGroupIds) ? item.excludeGroupIds : []
      const guestCount = getters.getGuestCountByExcludeGroupIds(excludeGroupIds)
      const rawBaseMax = Number((item.quantity && item.quantity.max) || 10)
      const hasBaseMax = Number.isFinite(rawBaseMax) && rawBaseMax > 0
      const byGuest = Boolean(item.quantityByGuest === true)

      let computedMax
      if (hasBaseMax) {
        computedMax = byGuest
          ? rawBaseMax * guestCount
          : rawBaseMax
      } else {
        computedMax = 10
      }

      const returnItem = {
        ...item,
        quantityByOrder: Boolean(item.quantityByOrder),
        quantityByGuest: byGuest,
        quantity: {
          ...item.quantity,
          max: Math.floor(computedMax) // 주문가능한 최대값 수정 (originMax)
        }
      }
      return returnItem
    },
    getDetailItem: (state) => {
      const detailItemId = state.detailItemId
      return state.itemProperty && state.itemProperty[detailItemId]
    },
    getDetailItemId: state => state.detailItemId,
    getDetailOptions: state => state.detailOptions,
    getDetailItemInfo: state => state.detailItemInfo,
    getPresetProperty: (state) => (presetType, presetId) => {
      const preset = state.preset[presetType] && state.preset[presetType][presetId]
      const property = presetType === 'availableTime'
        ? preset
          ? setAvailableTimeTable(preset.presetOptions)
          : setAvailableTimeTable(state.defaultAvailableTime)
        : preset
          ? preset.presetOptions[0]
          : null
      function setAvailableTimeTable(timeTable) {
        return timeTable && timeTable.map(x => {
          return {
            ...x,
            time: x.time.map(t => {
              const timeFrom = t.from.hh && t.from.mm ? `${t.from.hh}:${t.from.mm}` : t.from
              const timeTo = t.to.hh && t.to.mm ? `${t.to.hh}:${t.to.mm}` : t.to
              return {
                from: timeFrom,
                to: timeTo
              }
            })
          }
        })
      }
      return property
    },
    getShopCatCode: state => (shopPageId) => state.catCodes && state.catCodes[shopPageId],
    getShopResultData: () => (code) => {
      let result = true
      switch (code) {
        case 301:
          result = 'invalid_available_time' // 이용시간 아님
          break
        case 302:
          result = 'invalid_option_item' // 옵션의 상품이 유효하지 않음
          break
        case 303:
          result = 'exist_shop_guest_info' // 해당catCode에 이미 인원정보가 등록되어 있음
          break
        case 304:
          result = 'not_exist_shop_guest_info' // 해당catCode에 인원정보가 등록되어 있지 있음
          break
        case 305:
          result = 'over_order_time' // 주문가능시간 초과
          break
        case 306:
          result = 'over_limit_item_quantity' // 주문 가능 아이템 수량초과
          break
        case 307:
          result = 'waiting_order_time' // 아직 주문대기시간
          break
        case 308:
          result = 'over_limit_order_count' // 주문 가능 횟수초과
          break
        case 309:
          result = 'over_limit_category_count' // 카테고리 내 주문 가능 수량s초과
          break
        // 351~500까지는 공통에러
        case 351:
          result = 'invalid_format' // 형식에 맞지 않는 정보(invalid format)
          break
        case 401:
          result = 'inactivate_service' // 비활성화 또는 서비스 하지 않는 사이트
          break
        case 403:
          result = 'invalid_request_data' // 유효하지 않은 요청 데이터
          break
        case 405:
          result = 'invalid_siteid' // 사이트 정보가 없음
          break
        case 406:
          result = 'not_found_data' // 데이터가 없음
          break
        case 500:
          result = 'system_error' // 내부 오류
          break
      }
      return result
    },
    getShopItemPrice: () => (shopItem) => {
      const details = shopItem && shopItem.payload
      const itemPrice = Number(details && details.priceInfo && details.priceInfo.gross) || 0 //상품자체 단가
      const itemQuantity = details.quantity || 1
      const options = details && details.options && details.options.flatMap(x => x.optionItems)
      const optionTotal = options ? options.reduce((sum, item) => sum + Number((item && item.priceInfo && item.priceInfo.gross) || 0) * (item.quantity || 1), 0) : 0
      return {
        itemPrice: itemPrice,
        itemQuantity: itemQuantity,
        optionPrice: optionTotal,
        total: (itemPrice + optionTotal) * itemQuantity
      }
    },
    getItemStatus: state => presetId => {
      const status = state.preset && state.preset.status
      return (status && status[presetId]) || null
    },
    getCategoryProperty: state => shopPageId => (shopPageId && state.categoryProperty && state.categoryProperty[shopPageId]) || {},
    getCategoryNav: state => shopPageId => {
      const categoryNav = (shopPageId && state.categoryNav && state.categoryNav[shopPageId]) || []
      // const categoryProperty = state.categoryProperty && state.categoryProperty[shopPageId]
      const hiddenGroup = state.hiddenGroup
      function traverse(node) {
        let filteredSub = []
        if (node.subCategory && node.subCategory.length > 0) {
          filteredSub = node.subCategory
            .map(traverse)
            .filter(Boolean)
        }
        const isSelfHidden = hiddenGroup.includes(node.categoryId)
        if (isSelfHidden || (node.subCategory && node.subCategory.length && filteredSub.length === 0)) return null

        return {
          categoryId: node.categoryId,
          categoryLabel: node.categoryLabel,
          ...(filteredSub.length > 0 && { subCategory: filteredSub })
        }
      }
      return categoryNav.map(traverse).filter(Boolean)
    },
    getCategoryNode: state => (shopPageId, categoryId) => { // 카테고리 트리에서 특정 카테고리 요소 반환ㄴ
      const categoryNav = (shopPageId && state.categoryNav && state.categoryNav[shopPageId]) || []
      function findNodeById(list, targetId, { idKey = 'categoryId', childrenKey = 'subCategory' } = {}) {
        if (!Array.isArray(list)) return null
        const stack = [...list] // 원본 보존
        while (stack.length) {
          const node = stack.pop()
          if (node && typeof node === 'object') {
            if (node[idKey] === targetId) return node
            const children = node[childrenKey]
            if (Array.isArray(children)) {
              for (let i = children.length - 1; i >= 0; i--) stack.push(children[i])
            }
          }
        }
        return null
      }
      return findNodeById(categoryNav, categoryId)
    },
    getHiddenItems: state => state.hiddenItems,
    getHiddenGroup: state => state.hiddenGroup,
    getActiveSubOption: state => state.activeSubOption,
    getDetailOptionArray: state => state.detailOptionArray,
    getOpenDetailOption: state => state.isOpenDetailOption,
    getOptionListData: (state, getters) => (shopPageId, shopItemId, optionArray, parentOptionId, parentOptionItemId) => {
      const excludeTax = getters.getShopSettings(shopPageId).excludeTax || false
      // 백엔드 option data(object)의 배열을 렌더링용 배열로 매핑
      return optionArray && optionArray.map((x, index) => {
        const isCheckbox = (x.optType || x.type).includes('check')
        const isCard = (x.optType || x.type).includes('card')
        const optionItems = x.optionItems.filter(o => o.isActive !== false).map((o, i) => {
          const optionItemPrice = o.priceInfo && (excludeTax ? (o.priceInfo.net || o.priceInfo.gross) : o.priceInfo.gross)
          return {
            optionItemId: o.optionItemId,
            name: o.name || o.shopItemName,
            isDefault: o.isDefault,
            price: optionItemPrice || o.price,
            quantity: 1,
            max: (o.quantity && o.quantity.max && parseInt(o.quantity.max)) || 1,
            ...o.pId && {
              pId: o.pId
            },
            ...o.thumb && {
              thumb: o.thumb
            },
            ...o.shopItemId && {
              shopItemId: o.shopItemId
            },
            ...o.status && {
              status: o.status
            },
            ...o.subOption && {
              subOption: o.subOption
            }
          }
        })
        return {
          ...x.optId && { // 스토어의 option.id + 프리셋의 optionIds[].id
            id: x.optId
          },
          ...x.optionId && { // 상품에서 직접등록한 option (submit할 때는 지워야함)
            // id: x.optionId,
            optionId: x.optionId
          },
          uniqueId: parentOptionId && parentOptionItemId ? `${shopItemId}_unique_${parentOptionId}_unique_${parentOptionItemId}_unique_${x.optId || x.optionId}` : `${shopItemId}_unique_${x.optId || x.optionId}`,
          name: x.optName || x.name,
          isRequired: x.isRequired,
          type: isCheckbox ? 'checkbox' : (x.optType || x.type),
          min: (isCheckbox || isCard) ? parseInt(x.typeOption.min) : 1,
          max: (isCheckbox || isCard) ? parseInt(x.typeOption.max) : 1,
          optionItems: optionItems,
          selected: (isCheckbox || isCard)
            ? optionItems.filter(o => !o.status && o.isDefault).map(o => o.optionItemId)
            : optionItems.find(o => !o.status && o.isDefault) // is select
              ? optionItems.find(o => !o.status && o.isDefault).optionItemId
              : x.isRequired ? !optionItems[0].status && optionItems[0].optionItemId : ''
        }
      })
    },
    isItemValid: state => shopItemId => {
      const item = state.itemProperty[shopItemId]
      if (!item) return null
      // 이용가능시간과 판매불가상태인지 체크해야함
      const hasAvailableTime = item.availableTime && item.status
      return item
    },
    getCallStaff: state => state.callStaff,
    getShopCurrency: state => state.currencyCode || '',
    getShopGuest: state => state.shopGuest,
    getShopOrderTimeout: state => shopPageId => state.shopOrderTimeout && state.shopOrderTimeout[shopPageId],
    getBillingCount: state => state.billingCount,
    getBillingCountByShopItemId: state => (catCode, shopItemId) => {
      /**
       * shopItemId에 따른 빌링 qty
       * 주문가능 수량 계산시 총수량에서 이 값이 포함되어 차감
       */
      const billingCountCatcode = state.billingCount && state.billingCount[catCode]
      const billingCountItem = billingCountCatcode && billingCountCatcode.shopItemCounting
      return billingCountItem && billingCountItem[shopItemId]
    },
    getBillingCountByCategoryId: state => (catCode, categoryId) => {
      const billingCountCatcode = state.billingCount && state.billingCount[catCode]
      const billingCountCategory = billingCountCatcode && billingCountCatcode.categoryCounting
      return billingCountCategory && billingCountCategory[categoryId]
    },
    getBillingStartTime: state => catCode => state.billingInfo && state.billingInfo[catCode] && state.billingInfo[catCode].startDate,
    getLastOrderTime: state => catCode => state.billingInfo && state.billingInfo[catCode] && state.billingInfo[catCode].lastOrderDate,
    getWaitingOrder: state => catCode => state.waitingOrder && state.waitingOrder[catCode],
    getIgnoreWaitingItem: state => shopItemId => {
      const itemProperty = state.itemProperty && state.itemProperty[shopItemId]
      return itemProperty && itemProperty.ignoreLimit && itemProperty.ignoreLimit.waiting
    },
    getItemPossibleMax: (state, getters, rootState, rootGetters) => (catCode, shopItemId, isStore) => {
      const item = getters.getItemProperty(shopItemId, isStore)
      if (!item || !item.quantity) return 10

      const billingCount = Number(getters.getBillingCountByShopItemId(catCode, shopItemId)) || 0
      const cartItems = rootGetters['cart/findCartShopItems'](catCode, shopItemId) || []

      const isQuantityByOrder = Boolean(item.quantityByOrder)
      // 빌링 qty 카운트
      const itemBillingCount = isQuantityByOrder ? billingCount : 0
      // 지금 장바구니에 담아놓은 qty 카운트
      const itemCartCount = cartItems && cartItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
      const max = Number((item.quantity && item.quantity.max) || 10)
      const totalMax = max - itemBillingCount - itemCartCount

      return Math.max(totalMax, 0)
    },
    getCategoryLimitSettings: state => categoryId => {
      const limitSettings = state.categoryLimitSettings && state.categoryLimitSettings[categoryId]
      if (!limitSettings) return null

      return limitSettings && limitSettings.limitItemCount
    },
    getCategoryLimitCount: (state, getters, rootState, rootGetters) => (shopPageId, catCode, categoryId) => {
      const limit = getters.getCategoryLimitSettings(categoryId)
      if (!limit || limit.active !== true) return null

      const itemCount = Math.max(0, Number(limit.itemCount) || 0)
      const excludeGuestGroupIds = Array.isArray(limit.excludeGuestGroupIds) ? limit.excludeGuestGroupIds : []
      const guestCount = getters.getGuestCountByExcludeGroupIds(excludeGuestGroupIds)
      const billingCount = Math.max(0, Number(getters.getBillingCountByCategoryId(catCode, categoryId)) || 0)

      // 1. max
      const max = limit.countByGuest === true
        ? guestCount * itemCount
        : itemCount

      // 2) 카테고리 장바구니 수량 합계
      //    - cartId에 'shop_' 포함인 것만 1차 필터
      //    - payload.categoryId 일치하는 것만 2차 필터
      //    - 수량은 item.payload.quantity 사용(없으면 0)
      const cartList = rootGetters['cart/getList'](shopPageId) || []

      const cartItemCount = cartList
        .filter(item => item.cartId.includes('shop_'))
        .filter(item => item.payload && item.payload.categoryId === categoryId)
        .reduce((sum, item) => sum + (Number(item.payload && item.payload.quantity) || 0), 0)

      // 3) possibleMax
      //    - 결제 누적 차감은 countByOrder=true일 때만
      //    - 장바구니 차감은 항상
      const countByOrder = limit.countByOrder
      const categoryBillingCount = countByOrder === true ? billingCount : 0
      const possibleMax = Math.max(0, max - categoryBillingCount - cartItemCount)

      return { max, billingCount, cartItemCount, possibleMax, countByOrder }
    },
    getGuestCountByExcludeGroupIds: (state, getters) => (excludeGroupIds) => {
      const guestInfos = (getters.getShopGuest && getters.getShopGuest.guestInfos) || []
      const excludeIds = Array.isArray(excludeGroupIds) ? excludeGroupIds : []

      if (!guestInfos.length) return 1
      if (!excludeIds.length) {
        return guestInfos.reduce((sum, info) => sum + (Number(info.count) || 0), 0)
      }

      const count = guestInfos.reduce((sum, info) => {
        const groupId = info.groupId
        const guestCount = Number(info.count) || 0
        return excludeIds.includes(groupId)
          ? sum
          : sum + guestCount
      }, 0)

      return Math.max(0, count)
    },
    getItemPrice: (state, getters) => (shopPageId, shopItemId) => {
      const shopItem = getters.getItemProperty(shopItemId)
      const priceInfo = shopItem && shopItem.priceInfo
      const excludeTax = getters.getShopSettings(shopPageId).excludeTax || false
      return priceInfo && (excludeTax ? (priceInfo.net || priceInfo.gross) : priceInfo.gross)
    },
    getIsStoreGuestCount: state => state.isShopGuestCount
  }
}
